import axios from 'axios';
import VueAxios from 'vue-axios';
import { get, post } from '@/service/request';

export function setupAxios(app) {
    app.use(VueAxios, axios);
    app.provide('$post', post);
    app.provide('$get', get);
}
